export const LIMIT_SEATS = 8;
